/**
 * スキルマップテーブルコンポーネント全体で使用される定数の定義
 */

import styles from './style.scss';

// ========== SCSSからインポートした値をパース ==========
const parsePixelValue = (value: string): number => {
  return parseInt(value.replace('px', ''), 10);
};

const SCSS_VALUES = {
  BASE_FONT_SIZE: parsePixelValue(styles.baseFontSize),
  BASE_PADDING_UNIT: parsePixelValue(styles.basePaddingUnit),
  BASE_BORDER_WIDTH: parsePixelValue(styles.baseBorderWidth),
  CELL_PADDING_V: parsePixelValue(styles.cellPaddingVertical),
  CELL_PADDING_H: parsePixelValue(styles.cellPaddingHorizontal),
  FIXED_CELL_PADDING_V: parsePixelValue(styles.fixedCellPaddingVertical),
  FIXED_CELL_PADDING_H: parsePixelValue(styles.fixedCellPaddingHorizontal)
} as const;

// ========== 幅設定の定数 ==========
/**
 * 列幅の制約
 * - FIXED_COLUMN: 固定列（左端の名前列）の幅制約
 * - DATA_COLUMN: データ列（細項目列）の幅制約
 */
export const WIDTH_CONSTRAINTS = {
  FIXED_COLUMN: { MIN: 100, MAX: 200, DEFAULT: 150 },
  DATA_COLUMN: { MIN: 46, MAX: 200, DEFAULT: 150 }
} as const;

// ========== スペーシングの定数 ==========
/**
 * セルのパディングとボーダーの設定
 */
export const CELL_SPACING = {
  HEADER: {
    PADDING_H: SCSS_VALUES.CELL_PADDING_H,  // 横方向のパディング
    PADDING_V: SCSS_VALUES.CELL_PADDING_V,  // 縦方向のパディング
    BORDER: SCSS_VALUES.BASE_BORDER_WIDTH   // ボーダー幅
  },
  FIXED: {
    PADDING_H: SCSS_VALUES.FIXED_CELL_PADDING_H, // 横方向のパディング
    PADDING_V: SCSS_VALUES.FIXED_CELL_PADDING_V, // 縦方向のパディング
    BORDER: SCSS_VALUES.BASE_BORDER_WIDTH * 2    // ボーダー幅（left + right）
  }
} as const;

/**
 * 計算済みの合計スペース
 * セルの実際の幅を計算する際に使用
 */
export const TOTAL_SPACING = {
  // ヘッダー: パディング×2 + ボーダー + アイコン幅
  // +22 はソートアイコンの幅
  HEADER: CELL_SPACING.HEADER.PADDING_H * 2 + CELL_SPACING.HEADER.BORDER + 22,
  // 固定列: パディング×2 + ボーダー
  FIXED: CELL_SPACING.FIXED.PADDING_H * 2 + CELL_SPACING.FIXED.BORDER
} as const;

// ========== テキスト測定用の設定 ==========
/**
 * テキスト幅測定用の要素スタイル設定
 */
export const MEASURE_ELEMENT_CONFIG = {
  position: 'absolute' as const,
  visibility: 'hidden' as const,
  height: 'auto',
  width: 'auto',
  whiteSpace: 'nowrap' as const,
  fontSize: `${SCSS_VALUES.BASE_FONT_SIZE}px`,
  fontWeight: 'bold',
  padding: '0',
  boxSizing: 'content-box' as const
} as const;
